//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { Fragment, useEffect } from 'react';
import { Menu, makeStyles } from '@material-ui/core';
import { ArrowDropDown } from '@material-ui/icons';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
import { setClassNameInDefns } from '../definitionHelper';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import AfitdButton from './AfitdButton';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = (params = {}) => {
    return makeStyles(theme => ({
        label: {
            '& span': {
                textTransform: 'capitalize',
                fontSize: '1rem',
                fontWeight: 'bold',
            },
        },
        menu: {
            '& .MuiPaper-root': {
                padding: '0 10px',
                width: '100%',
                borderRadius: '10px !important',
                maxWidth: '220px',
            },
            '& .MuiPaper-root::-webkit-scrollbar-track': {
                borderRadius: '10px',
                background: 'none',
            },
            '& .MuiPaper-root::-webkit-scrollbar': {
                width: '8px',
                backgroundColor: '#F5F5F5',
            },
            '& .MuiPaper-root::-webkit-scrollbar-thumb': {
                borderRadius: '10px',
                backgroundColor: 'rgba(0,0,0,0.2)',
            },
        },
    }));
};

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const { classes, props, closeMenu, openMenu, ref } = params;

    const { name, closeable } = props;

    const defns = {
        button: {
            endIcon: <ArrowDropDown />,
            'aria-controls': name,
            'aria-haspopup': 'true',
            onClick: openMenu,
            variant: 'text',
        },

        menu: {
            onClick: () => {
                closeable && closeMenu();
            },
            id: name,
            anchorEl: ref,
            keepMounted: true,
            open: Boolean(ref),
            onClose: closeMenu,
            getContentAnchorEl: null,
            anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
            transformOrigin: { vertical: 'top', horizontal: 'center' },
        },
    };

    // inject classes
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const AfitdMenu = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles(/*{param1, param2}*/)();

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    const [anchorEl, setAnchorEl] = React.useState(null);

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    useEffect(() => {
        if (props.close) setAnchorEl(null);
    }, [props.close]);

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------
    const handleClick = event => {
        if (props.onClick) props.onClick();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({
        classes,
        props,
        openMenu: handleClick,
        closeMenu: handleClose,
        ref: anchorEl,
    });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <Fragment>
            <AfitdButton {...defns.button}>{props.label}</AfitdButton>
            <Menu {...defns.menu}>{props.children}</Menu>
        </Fragment>
    );
};

export default AfitdMenu;
